import { Component } from '@angular/core';
import { JeevesInvoiceCardListComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'car-liner-invoice-card-list',
    templateUrl: './car-liner-invoice-card-list.component.html',
    styleUrl: './car-liner-invoice-card-list.component.scss',
    standalone: false
})
export class CarLinerInvoiceCardListComponent extends JeevesInvoiceCardListComponent {}
